// extracted by mini-css-extract-plugin
export default {"price":"r0-z","onSale":"s0-z","msrpLabelPrice":"t0-z","originalPrice":"u0-z","msrpLabel":"v0-z","percentOff":"w0-z"};